import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { PORTAL, usePortal } from '../portalAuth';
import { IMG } from '../components/StoreLayout';
import { STORE_BASE } from '../routeBase';

const ROWS = [
  { label: 'Category', key: 'category' },
  { label: 'Gender', key: 'gender' },
  { label: 'Material', key: 'material' },
  { label: 'Shape', key: 'shape' },
  { label: 'Frame Type', key: 'frame_type' },
  { label: 'Colour', key: 'color' },
  { label: 'Bridge Size', key: 'bridge_size' },
  { label: 'Temple Length', key: 'temple_length' },
  { label: 'Rim Height', key: 'rim_height' },
  { label: 'Frame Weight', key: 'frame_weight' },
  { label: 'Min. Order Qty', key: 'min_qty' },
];

export default function Compare() {
  const { customer, compare, setCompare, setCart, ready } = usePortal();
  const [busyId, setBusyId] = useState(null);

  if (!ready) return <div style={{ padding: 60, textAlign: 'center', color: '#aaa' }}>Loading…</div>;
  if (!customer) return (
    <div style={{ maxWidth: 500, margin: '60px auto', textAlign: 'center', padding: 20 }}>
      <i className="ti ti-arrows-right-left" style={{ fontSize: 44, color: '#ddd' }} />
      <h2 style={{ marginTop: 12 }}>Please sign in to compare products</h2>
      <Link to={`${STORE_BASE}/login`} className="sf-btn-outline" style={btn}>Sign in</Link>
    </div>
  );

  const remove = async variantId => {
    setBusyId(variantId);
    const r = await PORTAL.delete(`/compare/${variantId}`);
    setCompare(r.data);
    setBusyId(null);
  };
  const addToCart = async variantId => {
    setBusyId(variantId);
    try { const r = await PORTAL.post('/cart', { variant_id: variantId, qty: 1 }); setCart(r.data); }
    catch (e) { alert(e.response?.data?.error || 'Could not add to cart'); }
    setBusyId(null);
  };

  if (!compare.items.length) return (
    <div style={{ maxWidth: 500, margin: '60px auto', textAlign: 'center', padding: 20 }}>
      <i className="ti ti-arrows-right-left" style={{ fontSize: 44, color: '#ddd' }} />
      <h2 style={{ marginTop: 12 }}>Nothing to compare yet</h2>
      <p style={{ color: '#888', fontSize: 13.5, margin: '6px 0 0' }}>Tap the compare icon on any product (up to {compare.max}) to line them up here.</p>
      <Link to={`${STORE_BASE}/shop`} className="sf-btn-outline" style={btn}>Browse products</Link>
    </div>
  );

  return (
    <div style={{ maxWidth: 1100, margin: '24px auto', padding: '0 24px' }}>
      <h1 style={{ fontSize: 24, fontWeight: 700, marginBottom: 4 }}>Compare Products</h1>
      <p style={{ color: '#888', fontSize: 13, marginBottom: 20 }}>Comparing {compare.items.length} of {compare.max} products</p>

      <style>{`
        .sf-compare-scroll { overflow-x: auto; }
        .sf-compare-table { border-collapse: collapse; width: 100%; min-width: 560px; }
        .sf-compare-table th, .sf-compare-table td { padding: 12px 16px; border-bottom: 1px solid #eee; text-align: left; font-size: 13.5; white-space: nowrap; }
        .sf-compare-table th { background: #fafbfc; color: #888; font-size: 11.5; text-transform: uppercase; letter-spacing: .3px; font-weight: 700; white-space: normal; }
      `}</style>

      <div className="sf-compare-scroll">
        <table className="sf-compare-table">
          <thead>
            <tr>
              <th style={{ minWidth: 130 }}></th>
              {compare.items.map(it => (
                <th key={it.variant_id} style={{ minWidth: 190 }}>
                  <div style={{ position: 'relative' }}>
                    <button onClick={() => remove(it.variant_id)} disabled={busyId === it.variant_id} title="Remove"
                      style={{ position: 'absolute', top: -4, right: -4, border: 'none', background: '#fff', boxShadow: '0 1px 4px rgba(0,0,0,0.2)', borderRadius: '50%', width: 22, height: 22, cursor: 'pointer', color: '#c0392b', fontSize: 12 }}>
                      ×
                    </button>
                    <Link to={`${STORE_BASE}/product/${encodeURIComponent(it.model_no)}`} style={{ display: 'block', textDecoration: 'none', color: 'inherit' }}>
                      <div style={{ height: 100, background: '#fafafa', borderRadius: 8, display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 8 }}>
                        {it.image ? <img src={IMG(it.image)} alt="" loading="lazy" style={{ maxWidth: '80%', maxHeight: '80%', objectFit: 'contain' }} /> : <i className="ti ti-eyeglass-2" style={{ color: '#ddd', fontSize: 28 }} />}
                      </div>
                      <div style={{ fontWeight: 700, fontSize: 14, color: '#191919' }}>{it.model_no}</div>
                    </Link>
                    {it.price != null && <div style={{ fontWeight: 700, color: 'var(--sf-primary)', fontSize: 13.5, marginTop: 4 }}>{compare.currency} {it.price}</div>}
                    <button onClick={() => addToCart(it.variant_id)} disabled={busyId === it.variant_id} className="sf-btn-outline"
                      style={{ marginTop: 8, width: '100%', border: '1.5px solid var(--sf-accent)', borderRadius: 18, padding: '6px 8px', fontSize: 11.5, fontWeight: 600, cursor: 'pointer' }}>
                      Add to Cart
                    </button>
                  </div>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {ROWS.map(row => (
              <tr key={row.key}>
                <td style={{ fontWeight: 600, color: '#555' }}>{row.label}</td>
                {compare.items.map(it => (
                  <td key={it.variant_id}>{it[row.key] || <span style={{ color: '#ccc' }}>—</span>}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

const btn = { display: 'inline-block', marginTop: 18, padding: '10px 24px', borderRadius: 22,
  border: '1.5px solid var(--sf-accent)', textDecoration: 'none', fontSize: 14, fontWeight: 600 };
